import { api } from "./axiosClient";
import type { ProviderRegistry } from "../types/providerRegistry.types";

export const providerRegistryApi = {
  searchProviderRegistries: async (payload: any) => {
    const response = await api.post("/providerRegistry/Search", payload);
    return response.data;
  },

  createproviderRegistry: async (data: Partial<ProviderRegistry>) => {
    const response = await api.post("/providerRegistry/create", data);
    return response.data;
  },

  updateproviderRegistry: async (data: Partial<ProviderRegistry>) => {
    const response = await api.post("/providerRegistry/edit", data);
    return response.data;
  },

  removeproviderRegistry: async (id: string) => {
    return await api.post("/providerRegistry/remove", { id });
  },

  setProviderRegistryStatus: async (id: string, status: number) => {
    const response = await api.post("/providerRegistry/setstatus", {
      id,
      status,
    });
    return response.data;
  },
};
